import React from 'react'
import PropTypes from 'prop-types'

import Search from '../Search'
import ColumnsDropdown from '../ColumnsDropdown'
import FilterDropdown from '../FilterDropdown'

const TopControls = ({ topControls, tablePayload, filterGroupsConfig, hideColumnsDropdown, disabled }) => {
  if (topControls === false) return false
  if (topControls) return topControls

  return (
    <div className='row w-100 g-2 mb-4'>
      <div className='col-12 col-lg-3'>
        <Search
          search={tablePayload.search}
          setSearchTerm={tablePayload.setSearchTerm}
          disabled={disabled}
        />
      </div>
      {!hideColumnsDropdown &&
        <div className='col-auto'>
          <ColumnsDropdown
            schema={tablePayload.schema}
            setSchema={tablePayload.setSchema}
            stickyColumn={tablePayload.stickyColumn}
            setSticky={tablePayload.setSticky}
            disabled={disabled}
          />
        </div>
      }
      <div className='col-auto'>
        <FilterDropdown
          filters={tablePayload.filters}
          setFilters={tablePayload.setFilters}
          scrubFilters={tablePayload.scrubFilters}
          filterOptions={tablePayload.filterOptions}
          schema={tablePayload.schema}
          disabled={disabled}
          filterGroupsConfig={filterGroupsConfig}
        />
      </div>
    </div>
  )
}

TopControls.propTypes = {
  topControls: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element
  ]),
  tablePayload: PropTypes.object,
  disabled: PropTypes.bool,
  filterGroupsConfig: PropTypes.array,
  hideColumnsDropdown: PropTypes.bool
}

export default TopControls
